import { ApiResponse, Meta, TicketReportingOption } from '@vision/ui/interfaces';

export interface TicketReportingOptionResponseDto {
  id: string;
  name: string;
  key?: string;
  system?: boolean;
  project_id?: string;
  project_name?: string;
  project?: {
    id: string;
    name: string;
  };
  ticket_project?: {
    id: string;
    name: string;
  };
}

interface TicketReportingOptionsResponseDto {
  data?: TicketReportingOptionResponseDto[];
  meta?: Partial<Meta> | null;
  object?: ApiResponse<TicketReportingOption[]>['object'];
  url?: string;
}

export function normalizeTicketReportingOption(dto: TicketReportingOptionResponseDto): TicketReportingOption {
  const project = dto.project ?? dto.ticket_project;

  return {
    id: dto.id,
    name: dto.name,
    key: dto.key,
    system: dto.system,
    projectId: project?.id ?? dto.project_id,
    projectName: project?.name ?? dto.project_name,
  };
}

export function normalizeTicketReportingOptionsResponse(
  response: TicketReportingOptionsResponseDto,
): ApiResponse<TicketReportingOption[]> {
  const pagination = response.meta?.pagination;

  return {
    data: (response.data ?? []).map(normalizeTicketReportingOption),
    meta: {
      filter_selections: response.meta?.filter_selections ?? [],
      filters: response.meta?.filters ?? [],
      generic_search_keys: response.meta?.generic_search_keys ?? [],
      pagination: {
        current: pagination?.current ?? 1,
        next: pagination?.next ?? 0,
        per_page: pagination?.per_page ?? response.data?.length ?? 0,
        previous: pagination?.previous ?? 0,
        total_count: pagination?.total_count ?? response.data?.length ?? 0,
        total_pages: pagination?.total_pages ?? 1,
      },
      searchable: response.meta?.searchable ?? true,
    },
    object: response.object ?? 'collection',
    ...(response.url ? { url: response.url } : {}),
  };
}
